export const get = <T>(obj: T, path: string): unknown => path
  .split('.')
  .reduce((value, pathPart) => value?.[pathPart], obj);
